module.exports = __webpack_public_path__ + "static/media/social_media_content_landingpage.082a850f.webp";